import {EmbedCodeExtractor} from "./types"

/**
 * Patterns of Tik::WebEmbedService::PreProcessor::Telegram
 * (backend/mediaservice/lib/tik/web_embed_service/pre_processor/telegram.rb).
 *
 * Sample Telegram embed codes:
 *   <script async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-post="channel_name/123" data-width="100%"></script>
 *   <iframe src="https://t.me/channel_name/123?embed=1" width="100%" height="400" frameborder="0"></iframe>
 */
const PATTERNS = [
  // Script tag with data-telegram-post attribute
  /data-telegram-post=["']([^"'/]+\/\d+)["']/i,
  // Iframe with t.me URL
  /<iframe[^>]*src=["'](https?:\/\/t\.me\/[^"']+)["']/i,
  // Iframe with telegram.me URL
  /<iframe[^>]*src=["'](https?:\/\/telegram\.me\/[^"']+)["']/i
]

/** Port of PreProcessor::Telegram — embed code → canonical t.me/telegram.me post URL. */
export const telegramPreProcessor: EmbedCodeExtractor = (input: string): string | null => {
  for(const pattern of PATTERNS) {
    const matchData = pattern.exec(input)
    if(matchData) {
      const first = matchData[1] ?? ""
      if(first.startsWith("http")) {
        // It's a full URL from iframe, clean up embed parameters
        let url = first
        // Remove embed=1 and other query parameters commonly used in embeds
        url = url.replace(/[?&]embed=1/g, "")
        url = url.replace(/[?&]width=\d+%?/g, "")
        url = url.replace(/[?&]userpic=false/g, "")
        // Clean up any leftover ? or & at the end
        url = url.replace(/[?&]$/g, "")
        return url
      }
      // It's a channel/post identifier from script tag, convert to URL
      return `https://t.me/${first}`
    }
  }
  return null
}
